"use client";

import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

export const TopShopTooltipContents: React.FC = () => {
  return (
    <Column>
      <StyledTypography>
        <StrictLocalMsg
          id="MeUyyS"
          defaultMessage="To earn Top Shop status, brands must:"
          description={{
            text: "Header of a education tooltip that educates retailers what a brand needs to do to become a Top Shop",
            img: "https://cdn.faire.com/fastly/6dc2f724a9541d212bc45a08e3f1558ef825cbb4a50acaec4330dd81d3e4ea45.png",
          }}
        />
      </StyledTypography>
      <Spacer size="2x" />
      <ul>
        <StyledListItem>
          <StyledTypography>
            <StrictLocalMsg
              id="/9R8d/"
              defaultMessage="Earn a 4.8+ rating over the last 12 months"
              description={{
                text: "Bullet point in a tooltip explaining what qualifies brands for Top Shop, Faire's quarterly program that recognizes the best brands",
                img: "https://cdn.faire.com/fastly/6dc2f724a9541d212bc45a08e3f1558ef825cbb4a50acaec4330dd81d3e4ea45.png",
              }}
            />
          </StyledTypography>
        </StyledListItem>
        <StyledListItem>
          <StyledTypography>
            <StrictLocalMsg
              id="bJ/jcL"
              defaultMessage="Fulfill orders quickly & smoothly"
              description={{
                text: "Bullet point in a tooltip explaining what qualifies brands for Top Shop, Faire's quarterly program that recognizes the best brands",
                img: "https://cdn.faire.com/fastly/6dc2f724a9541d212bc45a08e3f1558ef825cbb4a50acaec4330dd81d3e4ea45.png",
              }}
            />
          </StyledTypography>
        </StyledListItem>
        <StyledListItem>
          <StyledTypography>
            <StrictLocalMsg
              id="gz5fML"
              defaultMessage="Run a world-class shop page"
              description={{
                text: "Bullet point in a tooltip explaining what qualifies brands for Top Shop, Faire's quarterly program that recognizes the best brands",
                img: "https://cdn.faire.com/fastly/6dc2f724a9541d212bc45a08e3f1558ef825cbb4a50acaec4330dd81d3e4ea45.png",
              }}
            />
          </StyledTypography>
        </StyledListItem>
        <StyledListItem>
          <StyledTypography>
            <StrictLocalMsg
              id="m2Td+g"
              defaultMessage="Maintain a fresh catalog"
              description={{
                text: "Bullet point in a tooltip explaining what qualifies brands for Top Shop, Faire's quarterly program that recognizes the best brands",
                img: "https://cdn.faire.com/fastly/6dc2f724a9541d212bc45a08e3f1558ef825cbb4a50acaec4330dd81d3e4ea45.png",
              }}
            />
          </StyledTypography>
        </StyledListItem>
      </ul>
    </Column>
  );
};

const StyledTypography = styled(Typography).attrs({
  color: Core.text.inverse,
})``;

const StyledListItem = styled.li`
  list-style-type: disc;
  margin-left: ${getSpacing("3x")};
`;
